$(".sfyn-hero-slider").slick({
  arrows: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 1500,
  slidesToShow: 1,
  slidesToScroll: 1,
});

$(".sfyn-img-slider").slick({
  arrows: false,
  dots: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 667,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$(".sfyn-cards-slider").slick({
  arrows: false,
  dots: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 667,
      settings: {
        arrows: true,
        dots: true,
        centerMode: false,
        slidesToShow: 1,
      },
    },
  ],
});

$(".sfyn-success-slider").slick({
  arrows: true,
  dots: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 667,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$(".sfyn-partner-slider").slick({
  arrows: true,
  dots: true,
  slidesToShow: 4,
  rows: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 667,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
});

$(".sfyn-faq-title").on("click", function () {
  $(this).parent(".sfyn-faq-item").toggleClass("sfyn-active-faq-item");
  $(this).next(".sfyn-faq-body").slideToggle();

  $(".sfyn-faq-title").not(this).next(".sfyn-faq-body").slideUp();
  $(".sfyn-faq-item")
    .not($(this).parent(".sfyn-faq-item"))
    .removeClass("sfyn-active-faq-item");
});
// $(".sfyn-faq-item:first-child .sfyn-faq-body").slideDown();
// $(".sfyn-faq-item:first-child").addClass("sfyn-active-faq-item");

document.addEventListener("DOMContentLoaded", function () {
  let overlay = document.querySelector("#overlay");
  let sidebarPanel = document.querySelector("#sidebar-panel");
  let myBody = document.querySelector(".add-classs-here");

  overlay.addEventListener("click", function (e) {
    sidebarPanel.classList.remove("open");
    myBody.classList.remove("open");
  });

  const sidebarContent = document.querySelector(".sidebar-content");
  const closeSidebar = document.getElementById("close-sidebar");
  const prevSlide = document.getElementById("prev-slide");
  const nextSlide = document.getElementById("next-slide");

  let currentSlideIndex = null;
  const links = Array.from(
    document.querySelectorAll(".sfyn-slider-card-item a")
  );

  if (!sidebarContent) {
    console.error("Sidebar content element not found.");
    return;
  }

  function loadSlide(index) {
    if (index < 0 || index >= links.length) return;

    currentSlideIndex = index;
    const url = links[index].href;
    //console.log("Fetching URL:", url);

    sidebarContent.innerHTML = "<p>Loading...</p>";
    sidebarPanel.classList.add("open");

    fetch(url)
      .then((response) => {
        //console.log("Fetch response:", response);
        if (response.ok) {
          return response.text();
        } else {
          throw new Error("Page not found");
        }
      })
      .then((html) => {
        //console.log("Fetched HTML:", html);
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const content = doc.querySelector("main"); // Adjust the selector to target the main content
        if (content) {
          sidebarContent.innerHTML = content.innerHTML;
        } else {
          sidebarContent.innerHTML = "<p>Error loading content.</p>";
        }
      })
      .catch((error) => {
        //console.error("Error loading content:", error);
        sidebarContent.innerHTML = "<p>Error loading content.</p>";
      });
  }

  links.forEach((link, index) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      loadSlide(index);
    });
  });

  closeSidebar.addEventListener("click", function () {
    sidebarPanel.classList.remove("open");
    myBody.classList.remove("open");
  });

  prevSlide.addEventListener("click", function () {
    if (currentSlideIndex !== null) {
      loadSlide(currentSlideIndex - 1);
    }
  });

  nextSlide.addEventListener("click", function () {
    if (currentSlideIndex !== null) {
      loadSlide(currentSlideIndex + 1);
    }
  });
});

// $(".sfyn-menu-prd-grid").slideUp();
// $("#HeaderMenu-product").mouseover(function () {
//   $(".sfyn-menu-prd-grid").slideDown("slow");
// });
// $(".sfyn-menu-prd-grid").mouseout(function () {
//   $(".sfyn-menu-prd-grid").slideUp("slow");
// });

$('.custom-announcement-bar a[href*="#"]').on("click", function (e) {
  e.preventDefault();

  $("html, body").animate(
    {
      scrollTop: $($(this).attr("href")).offset().top,
    },
    1000,
    "linear"
  );
});

$(".fake-btn").click(function () {
  $(this).siblings().removeClass("active-fake-btn");
  $(this).addClass("active-fake-btn");
});
$(".fake-btn:first-child").addClass("active-fake-btn");
$(".starterbundle .fake-btn:first-child").removeClass("active-fake-btn");
$(".starterbundle .fake-btn:not(:first-child)").addClass("active-fake-btn");

// $(
//   "div#shopify-section-template--22794241245463__custom_faqs_YhWcGH .sfyn-btn"
// ).on("click", function () {
//   $(
//     "div#shopify-section-template--22794241245463__custom_faqs_YhWcGH .sfyn-faqs-block"
//   ).slideUp();
// });

// $(
//   "div#shopify-section-template--22794241245463__custom_faqs_DHNAtW .sfyn-btn"
// ).on("click", function () {
//   $(
//     "div#shopify-section-template--22794241245463__custom_faqs_DHNAtW .sfyn-faqs-block"
//   ).slideUp();
// });

$(document).ready(function () {
  $(
    ".custom-faqs-template--22794241245463__custom_faqs_DHNAtW .sfyn-btn"
  ).click(function (e) {
    e.preventDefault();
    $(".custom-faqs-template--22794241245463__custom_faqs_DHNAtW").toggleClass(
      "closed"
    );
  });
});

$(document).ready(function () {
  $(
    ".custom-faqs-template--22794241245463__custom_faqs_YhWcGH .sfyn-btn"
  ).click(function (e) {
    e.preventDefault();
    $(".custom-faqs-template--22794241245463__custom_faqs_YhWcGH").toggleClass(
      "closed"
    );
  });
});
$(document).ready(function () {
  $(".custom-faqs-template--22794241245463__custom_faqs_YhWcGH .sfyn-btn").on(
    "click",
    function (e) {
      e.preventDefault();
      $(
        ".custom-faqs-template--22794241245463__custom_faqs_YhWcGH .sfyn-faq-item"
      )
        .slice(4)
        .slideUp();
    }
  );
});

$(document).ready(function () {
  $(".custom-faqs-template--22794241245463__custom_faqs_DHNAtW .sfyn-btn").on(
    "click",
    function (e) {
      e.preventDefault();
      $(
        ".custom-faqs-template--22794241245463__custom_faqs_DHNAtW .sfyn-faq-item"
      )
        .slice(4)
        .slideUp();
    }
  );
});

jQuery(function ($) {
  gap = 20;
  mainSection = $(".custom-formula-cards.section");
  sliderContainer = $(".div3");
  sliderTrack = $(".div4");
  slide = $(".div5");
  scroller = $(".content-scroll");
  slideWidth = sliderContainer.width();
  slides = sliderTrack.children().length;
  slideTrackWidth = slideWidth * slides + gap * (slides - 1);
  sectionHeight = slideWidth * (slides - 1);
  sectionPosition = mainSection.position();

  sliderTrack.css("width", slideTrackWidth + "px");
  slide.css("width", slideWidth);
  mainSection.css("height", "calc(100vh + " + sectionHeight + "px)");

  $(document).scroll(function () {
    // sectionPosition=$(".section").position();
    if ($(document).scrollTop() < sectionPosition.top) {
      positionLeft = 0;
    } else if (
      $(document).scrollTop() > sectionPosition.top &&
      $(document).scrollTop() < sectionPosition.top + sectionHeight
    ) {
      // console.log($(document).scrollTop());
      distance = $(document).scrollTop() - sectionPosition.top;
      gapDistance = gap * (slides - 1) * (distance / sectionHeight);
      positionLeft = -1 * (distance + gapDistance);
    }
    scroller.css("left", positionLeft + "px");
  });
});
